import { put, call, takeLatest } from "redux-saga/effects";
import { sensorConstants } from "../../constants/client";
import { callAPI } from "../commonApiCall";
import apiURLs from "../../config/url-config";
import { sensor, alertActions } from "../../actions";

function* listing(action) {
  try {
    const data = yield call(
      callAPI,
      apiURLs.sensorsUrl.getData,
      action.payload
    );

    if (data.status === true) {
      yield put(
        sensor.listingSuccess({
          list: data.data && data.data.list,
          total_active_sensor: data.data && data.data.active_sensor,
          total_in_active_sensor: data.data && data.data.in_active_sensor,
          total_virtual_sensor: data.data && data.data.virtual_sensor
        })
      );
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {}
}

export function* sensorSaga() {
  yield takeLatest(sensorConstants.LISTING_REQUEST, listing);
}
